import { ACTIONS } from "utils/actions"

export const IV_ROLE_ACTION = ACTIONS.chooseRandomUnverifiedSchool
export const SR_ROLE_ACTION = ACTIONS.chooseSemiVerifiedSchool
